import { ServerParseError, ServerError } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

import { getStore } from '@/config/redux'
import { showError } from '@/redux/appMessage/actions'
import { parseError } from '@/utils'
import { getIntl } from '@/utils/intlGlobalProvider'

import appMessages from '@/messages'

const getFailureMessage = (
  context: any,
  error: Error | ServerError | ServerParseError | undefined
) => {
  const { showFeedback } = context
  const intl = getIntl()
  let msg = intl.formatMessage(appMessages.negativeFeedback)

  if (showFeedback) {
    const { failure: failureMessage } = showFeedback

    if (failureMessage) {
      if (typeof failureMessage === 'function') {
        msg = failureMessage(error)
      } else if (typeof failureMessage === 'string') {
        msg = failureMessage
      }
    }
  }

  return msg
}

export default onError(
  ({ networkError, operation, graphQLErrors, forward }) => {
    const context = operation.getContext()
    const { dispatch } = getStore()

    if (networkError) {
      const msg = getFailureMessage(context, networkError)
      dispatch(showError(msg))

      return forward(operation)
    }

    if (graphQLErrors?.length) {
      const { showFeedback } = context
      const error = graphQLErrors[0]
      const errorObj = parseError(error)
      const { response } = errorObj

      if (showFeedback === false || showFeedback?.failure === false) {
        return forward(operation)
      }

      const msg = getFailureMessage(context, errorObj)

      if (response?.data && response?.status >= 403) {
        dispatch(showError(msg))

        return forward(operation)
      }
    }

    return undefined
  }
)
